import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./personal-editor-style.css";
import GenderMenu from "../../dialog/default-menu/DefaultMenuDialog";
import BirthTimeMenu from "../../dialog/default-menu/DefaultMenuDialog";
import CalenderPicker from "../../dialog/calender/calender-picker";
import ClockPicker from "../../dialog/clock/clock-picker";
import BirthplacePicker from "../../dialog/birthplace-picker/birthplace-picker";
import Menulist from "../../../constant/menulist";
import ModifyConfirmDialog from "../../dialog/confirm/confirm-dialog";
import ErrorModifyDialog from "../../dialog/confirm/confirm-dialog";
import ToastDialog from "../../dialog/toast/toast-dialog";
import AuthService from "../../../service/auth-service";
import UserService from "../../../service/user-service";
import SiteFooter from "../../custom/site-footer/site-footer";
import useIsMobile from "../../../hooks/useIsMobile";

const PersonalEditorComponent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  let navigate = useNavigate();
  const location = useLocation();
  const [srcData, setSrcData] = useState(location.state);
  const isMobile = useIsMobile();

  const [name, setName] = useState(srcData.userName);
  const [gender, setGender] = useState(srcData.userGender);
  const [birthDate, setBirthDate] = useState(srcData.userBirthDate);
  const [birthTimeSign, setBirthTimeSign] = useState(srcData.userBirthTimeSign);
  //真太陽時所需資料
  const [birthClockTime, setBirthClockTime] = useState(
    srcData.userBirthClockTime,
  );
  const [birthLongitude, setBirthLongitude] = useState(
    srcData.userBirthLongitude,
  );
  const [birthLatitude, setBirthLatitude] = useState(srcData.userBirthLatitude);

  //0：標準時間 / 1：真太陽時
  const [timeMode, setTimeMode] = useState(srcData.timeMode);
  const [foucsIndex, setFoucsIndex] = useState(-1);

  const [showGenderMenu, setShowGenderMenu] = useState(false);
  const [showBirthTimeMenu, setShowBirthTimeMenu] = useState(false);
  const [showSunTimeDes, setShowSunTimeDes] = useState(false);
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showToast, setShowToast] = useState(false);

  //出生地選擇（用 G-1 級聯查詢；選好後自動填 lng/lat，也可下方手動微調）
  const [showBirthplacePicker, setShowBirthplacePicker] = useState(false);
  const [birthPlaceName, setBirthPlaceName] = useState(
    srcData.userBirthPlace || "",
  );

  //picker 選定 callback
  const handleBirthplaceSelect = ({ fullName, lat, lng }) => {
    setBirthPlaceName(fullName || "");
    if (typeof lng === "number") setBirthLongitude(String(lng));
    if (typeof lat === "number") setBirthLatitude(String(lat));
  };

  const GENDER_MAP = Menulist.genderMap;
  const BIRTH_TIME_MAP = Menulist.birthTimeMap;

  //判斷編輯表單的資料是否有異動
  let isFormChange = Boolean(
    (name && srcData.userName != name) ||
    (gender && srcData.userGender != gender) ||
    (birthDate && srcData.userBirthDate != birthDate) ||
    (timeMode == "0"
      ? birthTimeSign && srcData.userBirthTimeSign != birthTimeSign
      : birthClockTime &&
        birthLongitude &&
        birthLatitude &&
        (srcData.userBirthClockTime != birthClockTime ||
          srcData.userBirthLongitude != birthLongitude ||
          srcData.userBirthLatitude != birthLatitude)),
  );

  //是否有動到命盤所需的資訊，這樣要跳出警告提醒
  const isFormChangeExceptName = isFormChange && srcData.userName == name;

  //確定更改按鈕的入口：先問後端 action=0「這樣改是否會影響命盤？」
  //  有異動 (resultCode=-1) → 彈警告 dialog（告知會刷新命盤 / 清解鎖狀態）
  //  沒異動或只改姓名 → 直接以 action=1 更新
  const handleModifyClick = async () => {
    try {
      if (!AuthService.getLoginStatus()) {
        AuthService.logout();
        navigate("/");
        return;
      }

      const probe = await UserService.modifyPersonalInfo(
        name,
        gender,
        birthDate,
        timeMode,
        birthTimeSign,
        birthClockTime,
        birthLongitude,
        birthLatitude,
        birthPlaceName,
        "0", //先探測
      );

      if (probe.data?.status && probe.data.data?.resultCode === "-1") {
        //命盤相關欄位有異動 → 彈警告，用戶確認後才 action=1
        setShowConfirmAlert(true);
        return;
      }

      //沒動命盤 → 直接更新
      await handleModifyInfo();
    } catch (e) {
      console.error("探測資料異動失敗：", e);
    }
  };

  //真正打 API 更新（action=1）
  //  被 handleModifyClick（沒動命盤）跟 ModifyConfirmDialog（動命盤且用戶確認）呼叫
  const handleModifyInfo = async () => {
    try {
      if (!AuthService.getLoginStatus()) {
        AuthService.logout();
        navigate("/");
        return;
      }

      const response = await UserService.modifyPersonalInfo(
        name,
        gender,
        birthDate,
        timeMode,
        birthTimeSign,
        birthClockTime,
        birthLongitude,
        birthLatitude,
        birthPlaceName,
        "1",
      );

      if (response.data.status) {
        const { userValidCode } = response.data.data;

        if (userValidCode == "2") {
          const updated = response.data.data;
          setShowToast(true);
          setSrcData(updated);

          setName(updated.userName);
          setGender(updated.userGender);
          setBirthDate(updated.userBirthDate);
          setTimeMode(updated.timeMode);
          setBirthTimeSign(updated.userBirthTimeSign);
          setBirthClockTime(updated.userBirthClockTime);
          setBirthLongitude(updated.userBirthLongitude);
          setBirthLatitude(updated.userBirthLatitude);
          setBirthPlaceName(updated.userBirthPlace || "");
        } else if (userValidCode == "1") {
          //註冊尚未完全
        } else {
          AuthService.logout();
          navigate("/");
        }
      }
    } catch (e) {
      console.error("獲取資料發生錯誤：", e);
    }
  };

  const editorCard = (
    <div className="editor-card">
      {/*你的姓名*/}
      <div className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}>
        <p>你的姓名</p>
        <input
          className="input-block"
          placeholder="請輸入姓名"
          maxLength={10}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onFocus={() => {
            setFoucsIndex(0);
          }}
        ></input>
      </div>
      {/*性別選單*/}
      <div
        className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
        onClick={(e) => {
          e.stopPropagation();
          setShowBirthTimeMenu(false);
          setShowSunTimeDes(false);
          setShowGenderMenu(!showGenderMenu);
        }}
      >
        <p>性別</p>
        <input
          className="input-block"
          placeholder="請選擇生理性別"
          readOnly
          value={GENDER_MAP[gender]}
          onFocus={() => {
            setFoucsIndex(1);
          }}
        ></input>
        <img src="../images/ic-brown-down.png"></img>
        {showGenderMenu && (
          <div className="float-menu">
            <GenderMenu
              dataMap={GENDER_MAP}
              onSuccess={(gender) => {
                setGender(gender);
              }}
              onClose={() => setShowGenderMenu(false)}
            ></GenderMenu>
          </div>
        )}
      </div>
      {/*出生日期日曆*/}
      <div className={`item-info  ${foucsIndex == 2 ? "foucs" : "non-focus"}`}>
        <p>出生日期</p>
        <CalenderPicker
          birthDate={birthDate}
          setBirthDate={setBirthDate}
          onFocus={() => {
            setFoucsIndex(2);
          }}
        />
        <img src="../images/ic-brown-down.png"></img>
      </div>
      {/*標準時間／太陽時選擇*/}
      <div className="select-radio">
        <div className="option">
          <input
            type="radio"
            name="method"
            id="standard"
            value="standard"
            checked={timeMode === "0"}
            onChange={() => setTimeMode("0")}
          />
          <label htmlFor="standard">標準時間</label>
        </div>

        <div className="option suntime">
          <input
            type="radio"
            name="method"
            id="sun"
            value="sun"
            checked={timeMode === "1"}
            onChange={() => setTimeMode("1")}
          />
          <label htmlFor="sun">真太陽時</label>

          <img
            onClick={(e) => {
              setShowGenderMenu(false);
              setShowBirthTimeMenu(false);
              setShowSunTimeDes(true);
              e.stopPropagation();
            }}
            src="../images/ic-description.png"
          ></img>

          <div className="suntime-tag">
            {showSunTimeDes && (
              <div
                className="suntime-des"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <p className="title">什麼是真太陽時？</p>
                <p className="des">
                  真太陽時（True Solar Time）是以天文學算式計算太陽
                  相對地平線的位置的時間，反映某地實際日照狀況。當
                  太陽位於當地子午線上時，即為「真正的中午」。它不同
                  於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                  太陽時會因地點與日期而有所變化，真太陽時則能根據
                  個人的出生經緯度，精確地還原當地的實際時間。
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/*出生時辰-標準時間選單*/}
      {timeMode == "0" && (
        <div
          className={`item-info menu ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
          onClick={(e) => {
            setShowSunTimeDes(false);
            setShowGenderMenu(false);
            setShowBirthTimeMenu(!showBirthTimeMenu);
            e.stopPropagation();
          }}
        >
          <p>出生時辰</p>
          <input
            className="input-block"
            placeholder="早子時 00:00-00:59"
            value={BIRTH_TIME_MAP[birthTimeSign]}
            readOnly
            onFocus={() => {
              setFoucsIndex(3);
            }}
          ></input>
          <img src="../images/ic-brown-down.png"></img>
          {showBirthTimeMenu && (
            <div className="float-menu">
              <BirthTimeMenu
                dataMap={BIRTH_TIME_MAP}
                onSuccess={(timeSign) => {
                  setBirthTimeSign(timeSign);
                }}
                onClose={() => setShowBirthTimeMenu(false)}
              ></BirthTimeMenu>
            </div>
          )}
        </div>
      )}
      {/*出生時辰-真太陽時選單*/}
      <div>
        {timeMode == "1" && (
          <div
            className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
            onClick={(e) => {
              setShowSunTimeDes(false);
              setShowGenderMenu(false);
              e.stopPropagation();
            }}
          >
            <p>出生時辰</p>

            <ClockPicker
              clockTime={birthClockTime}
              setClockTime={setBirthClockTime}
              onFocus={() => {
                setFoucsIndex(4);
              }}
            />

            <img src="../images/ic-brown-down.png"></img>
          </div>
        )}

        {/*快速選擇出生地：自己一格，跟出生時辰同層；選好自動填入下方經緯度*/}
        {timeMode == "1" && (
          <div
            className={`item-info menu ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
            onClick={(e) => {
              setShowSunTimeDes(false);
              setShowGenderMenu(false);
              setFoucsIndex(7);
              setShowBirthplacePicker(true);
              e.stopPropagation();
            }}
          >
            <p>選擇出生地</p>
            <span
              className="input-block"
              style={{
                marginLeft: isMobile ? "1rem" : "2rem",
                fontSize: isMobile ? "1rem" : "1.1rem",
                color: birthPlaceName ? undefined : "rgba(198, 198, 198)",
              }}
            >
              {birthPlaceName || "請選擇"}
            </span>
            <img src="../images/ic-brown-down.png"></img>
          </div>
        )}

        <div
          className={`warning ${timeMode == "1" ? "showBlock" : "hideBlock"}`}
        >
          * 選擇出生地後，將自動帶入該地經緯度
        </div>

        <div
          className={`born-place ${timeMode == "1" ? "showBlock" : "hideBlock"}`}
        >
          <div
            className={`item-info place ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
            onClick={(e) => {
              setShowSunTimeDes(false);
              setShowGenderMenu(false);
              e.stopPropagation();
            }}
          >
            <p>出生地-經度</p>

            <input
              type="number"
              className="input-block"
              min="-180"
              max="180"
              step="any"
              inputMode="decimal"
              placeholder="請輸入經度"
              value={birthLongitude}
              onChange={(e) => {
                setBirthLongitude(e.target.value);
              }}
              onFocus={() => {
                setFoucsIndex(5);
              }}
            ></input>
          </div>

          <div className="space"></div>

          <div
            className={`item-info place ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
            onClick={(e) => {
              setShowSunTimeDes(false);
              setShowGenderMenu(false);
              e.stopPropagation();
            }}
          >
            <p>出生地-緯度</p>

            <input
              className="input-block"
              type="number"
              step="any"
              inputMode="decimal"
              placeholder="請輸入緯度"
              min="-90"
              max="90"
              value={birthLatitude}
              onChange={(e) => {
                setBirthLatitude(e.target.value);
              }}
              onFocus={() => {
                setFoucsIndex(6);
              }}
            ></input>
          </div>
        </div>
      </div>

      <button
        className={`${isFormChange ? "active" : "disabled"}`}
        disabled={!isFormChange}
        onClick={handleModifyClick}
      >
        確定更改
      </button>
    </div>
  );

  const mainContent = (
    <main
      onMouseEnter={() => {
        setShowServiceMenu(false);
        setShowPersonalMenu(false);
      }}
      onClick={() => {
        setShowBirthTimeMenu(false);
        setShowGenderMenu(false);
        setShowSunTimeDes(false);
      }}
    >
      <div className="title">
        <img src="../images/ic-personal.png"></img>
        <span>編輯個人檔案</span>
      </div>

      {editorCard}

      {showConfirmAlert && (
        <div>
          <ModifyConfirmDialog
            open={showConfirmAlert}
            onClose={() => setShowConfirmAlert(false)}
            onSuccess={() => {
              setShowConfirmAlert(false);
              handleModifyInfo();
            }}
            title="偵測到重要資訊已變更"
            message="若確定變更，<br>將刷新個人命盤專屬解析，<br>如要重新解鎖命盤需再購買。"
            confirmTxt="確定更改"
            image="/images/ic-personal.png"
          />
        </div>
      )}

      {showErrorAlert && (
        <div>
          <ErrorModifyDialog
            open={showErrorAlert}
            onClose={() => setShowErrorAlert(false)}
            onSuccess={() => {}}
            title="無法更改個人資料"
            message="您三個月內已更改過檔案<br>如有問題，請洽官方Line客服"
            confirmTxt="知道了"
            image="/images/ic-personal.png"
          />
        </div>
      )}

      <ToastDialog
        open={showToast}
        onClose={() => {
          setShowToast(false);
        }}
        message="更新成功！"
      ></ToastDialog>
    </main>
  );

  const footerContent = <SiteFooter />;

  return (
    <div className="personal-editor-page">
      {/* 電腦版佈局 */}
      {!isMobile && (
        <div className="web-main">
          {mainContent}
          {footerContent}
        </div>
      )}

      {/* 手機版佈局 */}
      {isMobile && (
        <div className="mobile-main">
          {mainContent}
          {footerContent}
        </div>
      )}

      {/* 出生地級聯選擇（真太陽時模式下用） */}
      <BirthplacePicker
        open={showBirthplacePicker}
        onClose={() => setShowBirthplacePicker(false)}
        onSelect={handleBirthplaceSelect}
      />
    </div>
  );
};

export default PersonalEditorComponent;
